import React, { useEffect, useRef } from 'react';
import { Animated, View, StyleSheet, Dimensions } from 'react-native';

const { width } = Dimensions.get('window');

const RewardsSkeleton = () => {
  const translateX = useRef(new Animated.Value(-width)).current;

  useEffect(() => {
    const loopAnimation = () => {
      translateX.setValue(-width);
      Animated.timing(translateX, {
        toValue: width,
        duration: 1500,
        useNativeDriver: true,
      }).start(() => loopAnimation());
    };
    loopAnimation();
  }, []);

  const ShimmerOverlay = () => (
    <Animated.View
      style={[
        styles.shimmerOverlay,
        {
          transform: [{ translateX }],
        },
      ]}
    />
  );

  const SkeletonBox = ({ style }) => (
    <View style={[styles.skeletonBox, style]}>
      <ShimmerOverlay />
    </View>
  );

  return (
    <View style={styles.container}>
      <View style={styles.card}>
        <SkeletonBox style={styles.imagePlaceholder} />
        <SkeletonBox style={styles.title} />
        <SkeletonBox style={styles.textLine} />
        <SkeletonBox style={[styles.textLine, { width: '70%' }]} />
        <SkeletonBox style={[styles.textLine, { width: '60%' }]} />
        <SkeletonBox style={styles.button} />
        <SkeletonBox style={styles.price} />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
  },
  card: {
    width: 344,
    borderRadius: 12,
    backgroundColor: '#f2f2f2',
    padding: 20,
    overflow: 'hidden',
  },
  skeletonBox: {
    backgroundColor: '#e0e0e0',
    overflow: 'hidden',
    position: 'relative',
  },
  shimmerOverlay: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: 'rgba(255,255,255,0.5)',
    width: '50%',
    opacity: 0.6,
    transform: [{ rotate: '15deg' }],
  },
  imagePlaceholder: {
    width: '100%',
    height: 110,
    borderRadius: 12,
    marginBottom: 20,
  },
  title: {
    height: 20,
    width: '80%',
    borderRadius: 8,
    marginBottom: 10,
  },
  textLine: {
    height: 12,
    width: '90%',
    borderRadius: 6,
    marginBottom: 8,
  },
  button: {
    marginTop: 20,
    height: 45,
    width: '100%',
    borderRadius: 10,
  },
  price: {
    marginTop: 15,
    height: 12,
    width: 60,
    alignSelf: 'center',
    borderRadius: 6,
  },
});

export default RewardsSkeleton;
